import { FormikProps } from 'formik'
import { useEffect } from 'react'

import {
  CreateDemoTradingAccountFormValues,
  OuterProps,
} from '@pages/Traders-Room/Trading-Accounts/NewTradingAccount/Demo/CreateDemoTradingAccount.types'
import { useModals } from '@pages/Traders-Room/Trading-Accounts/NewTradingAccount/Demo/CreateDemoTradingAccountModals'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { AccountGroupType } from '@model/AccountGroupType'

export const useDemoTradingAccountFetch = (
  props: FormikProps<CreateDemoTradingAccountFormValues> & OuterProps,
  modalProps: ReturnType<typeof useModals>
) => {
  const { values } = props
  const { setAccountTypes, setClassificationTypes } = modalProps

  const apiClient = useApiClient(ClientApiClient)

  const fetchAccountTypes = async () => {
    if (values.platformType?.id && values.accountCurrency?.id) {
      const result = await apiClient.getAccountType(
        values.platformType.id,
        values.accountCurrency.id,
        AccountGroupType.Demo
      )
      setAccountTypes(result)
    }
  }

  const fetchClassificationTypes = async () => {
    const result = await apiClient.getTradingAccountClassificationType(
      values.platformType?.id!,
      values.accountCurrency?.id!,
      AccountGroupType.Demo,
      values.accountType?.id!
    )
    setClassificationTypes(result)
  }

  useEffect(() => {
    if (values.platformType?.id && values.accountCurrency?.id && values.accountType?.id) {
      fetchClassificationTypes()
    }

    if (values.platformType?.id && values.accountCurrency?.id && !values.accountType?.id) {
      fetchAccountTypes()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.platformType?.id, values.accountCurrency?.id, values.accountType?.id])
}
